module.exports = __webpack_public_path__ + "img/content-img3_1.7a4ba042.png";